import { SchoolService } from '@modules/school/school-service';
import Errors from '@shared/error/errors';
import Message from '@shared/message/message';
import { i18n } from '@shared/i18n';
import { omit } from 'lodash';
import { routerAsync } from '@/app-module';

export default {
  namespaced: true,

  state: {
    findLoading: false,
    saveLoading: false,
    record: null,
    schoolsMap: null,
    schoolsMapLoading: false,
  },

  getters: {
    findLoading: (state) => !!state.findLoading,
    saveLoading: (state) => !!state.saveLoading,
    record: (state) => state.record,
    schoolsMap: (state) => state.schoolsMap,
    schoolsMapLoading: (state) => !!state.schoolsMapLoading,
  },

  mutations: {
    RESET(state) {
      state.schoolsMap = {};
      state.findLoading = false;
      state.saveLoading = false;
      state.record = null;
    },

    FIND_STARTED(state) {
      state.record = null;
      state.findLoading = true;
    },

    FIND_SUCCESS(state, payload) {
      state.record = payload;
      state.findLoading = false;
    },

    FIND_ERROR(state) {
      state.record = null;
      state.findLoading = false;
    },

    CREATE_STARTED(state) {
      state.saveLoading = true;
    },

    CREATE_SUCCESS(state) {
      state.saveLoading = false;
    },

    CREATE_ERROR(state) {
      state.saveLoading = false;
    },

    UPDATE_STARTED(state) {
      state.saveLoading = true;
    },

    UPDATE_SUCCESS(state) {
      state.saveLoading = false;
    },

    UPDATE_ERROR(state) {
      state.saveLoading = false;
    },

    MAP_SCHOOLS_STARTED(state) {
      state.schoolsMap = {};
      state.schoolsMapLoading = true;
    },

    MAP_SCHOOLS_SUCCESS(state, payload) {      
      state.schoolsMapLoading = false;
      state.schoolsMap = payload;
    },

    MAP_SCHOOLS_ERROR(state) {
      state.schoolsMap = {};
      state.schoolsMapLoading = false;
    },
  },

  actions: {
    doNew({ commit }) {
      commit('RESET');
    },

    async doLoadSchools({ commit }, { subpropertyId, filter }) {
      try {
        commit('MAP_SCHOOLS_STARTED');
        const { orderBy, limit, offset } = [null, 0, 0]  ;
        const { rows } = await SchoolService.list(filter, orderBy, limit, offset, subpropertyId);

        const schoolsMap = rows.reduce((acum, { id, name, location}) => {
          acum[id] = { id, name, location }; 
          return acum;
        }, {});
                
        commit('MAP_SCHOOLS_SUCCESS', schoolsMap);
        // 1. Read teams 
      } catch (error) {
        Errors.handle(error);
        commit('MAP_SCHOOLS_ERROR');
      }
    },

    async doFind({ commit }, { id, subpropertyId }) {
      
      try {
        commit('FIND_STARTED');

        const record = await SchoolService.find(
          id,
          subpropertyId,
        );

        const emailsToSend = record.coaches.map(coach => coach.email);
        record.emails = emailsToSend;
        const recordToSend = omit(record, ['coaches']);

        commit('FIND_SUCCESS', recordToSend);
      } catch (error) {
        Errors.handle(error);
        commit('FIND_ERROR');
      }
    },

    async doCreate({ commit }, { values }) {
      try {
        commit('CREATE_STARTED');

        await SchoolService.create(values);
        commit('CREATE_SUCCESS');
        Message.success(
          i18n('entities.school.create.success'),
        );
      } catch (error) {
        Errors.handle(error);
        commit('CREATE_ERROR');
      }
    },

    async doUpdate(
      { commit },
      { id, data, manage },
    ) {
      try {
        commit('UPDATE_STARTED');

        await SchoolService.update(
          id,
          data,
          manage,
        );

        commit('UPDATE_SUCCESS');
        Message.success(
          i18n('entities.school.update.success'),
        );

        // Go back
        routerAsync().go(-1);
      } catch (error) {
        Errors.handle(error);
        commit('UPDATE_ERROR');
      }
    },
  },
};
